import * as React from 'react';

import { MessageContext } from '../../utils/messageContext';
import { EMessageType } from '../../types/messageType';
import { TMessage, TOutcomingStatus } from '../../types/messages';

type TMessageProviderProps = {
  message: TMessage & { status: TOutcomingStatus };
  messageId: string;
  chatId: string;
  messageType: EMessageType;
  isLastInChain: boolean;
  isFirstUserPhrase: boolean;
  messageRef: React.RefObject<HTMLDivElement | null>;
};

export const MessageProvider: React.FC<React.PropsWithChildren<TMessageProviderProps>> = ({
  message,
  messageId,
  chatId,
  messageType,
  isLastInChain,
  isFirstUserPhrase,
  messageRef,
  children,
}) => {
  const contextValue = React.useMemo(
    () => ({ message, messageId, chatId, messageType, isLastInChain, isFirstUserPhrase, messageRef }),
    [message, messageId, chatId, messageType, isLastInChain, isFirstUserPhrase, messageRef],
  );

  return <MessageContext.Provider value={contextValue}>{children}</MessageContext.Provider>;
};
